<template>
  <div class='header'>
    <router-link to="/">
    <img class="logo" src="@/assets/images/home/logo.png" alt="">
    </router-link>
    <div class='nav-list'>
      <router-link to="/">
        <span class='nav'>Home</span>
      </router-link>
      <router-link to="/AboutsUs">
        <span class='nav'>About Us</span>
      </router-link>
      <router-link to="/Contact">
        <span class='nav'>Contact</span>
      </router-link>
      <!--<router-link to="/Language">-->
        <!--<span class='nav'>Language</span>-->
      <!--</router-link>-->
      <!--<span class='nav'>Home</span>-->
      <!--<span class='nav active'>Abouts Us</span>-->
      <!--<span class='nav'>Contact</span>-->
      <!--<a class="language" @click="language">-->
        <!--<span class='nav'>En|中</span>-->
      <!--</a>-->
    </div>
  </div>
</template>

<script>
  export default {
    name: "headerNav",
    methods: {
      language: function () {
          if (this.$i18n.locale == 'zh_CN') {
            this.$i18n.locale = 'en_US';
          } else {
            this.$i18n.locale = 'zh_CN';
          }
      }
    }
  }
</script>

<style scoped>

  .nav-list a{
    color: #000;
    text-decoration: none;
  }
  .nav-list a.router-link-exact-active{
    color:#00787a;
  }
  .header{
    height: 4.3rem;
    min-height: 60px;
    padding: 0 2rem 0 2rem;
    display: flex;
    justify-content: space-between;
    align-items: center;
    box-shadow: #f3f2f2 1px -5px 20px 5px;
  }
  .header .logo{
    width: 14rem;
    min-width: 170px;
  }
  .header .nav-list{
    display: flex;
    flex-wrap: nowrap;
    font-size: 1.3rem;
  }
  .header .nav-list .nav{
    padding-left: 20px;
    margin-left: 20px;
    height: 20px;
    line-height: 20px;
    border-left: 1px solid #b7b7b7;
  }
  .header .nav-list .nav.active{
    color:#00787a
  }
  .header .nav-list .nav:first-child{
    border: none;
  }

  .header .nav-list .language {
    cursor: pointer;
  }


</style>



// WEBPACK FOOTER //
// src/components/header.vue